import * as React from 'react'
import { FormattedMessage } from 'react-intl'

import en from './locales/en.json'
import ro from './locales/ro.json'

import reducers from './redux/reducers'
import sagas from './redux/sagas'

export default {
  name: 'upcomings',
  menu: [
    {
      title: <FormattedMessage id="upcomings.menu.title" />,
      key: 'upcomings',
      url: '/upcomings',
      icon: 'icmn icmn-history',
      // roles: ['business'],
    },
  ],
  routes: [
    {
      path: '/upcomings',
      async lazy() {
        const Comp = await import('./pages')
        return { Component: Comp.default }
      },
      exact: true,
    },
  ],
  locales: {
    en,
    ro,
  },
  reducers,
  sagas,
}
